import React from 'react';

const AboutPage = () => {
  const cont = [
    {
      title: 'About Prevomics',
      content:
        "At Prevomics Healthscience, we are on a mission to transform healthcare through the power of genetic testing and personalized medicine. Our cutting-edge services provide individuals with the insights they need to make informed decisions about their health, unlock their genetic health potential, and optimize treatment plans for a healthier future.",
    },
    {
      title: 'Who We Are',
      content:
        "We are a team of dedicated geneticists, researchers, and healthcare professionals committed to advancing the field of personalized health. Our core philosophy is simple: every individual deserves healthcare that is as unique as their DNA. By leveraging the most advanced genetic technologies, we provide actionable insights that enable people to better understand their genetic makeup and take control of their health journey.",
    },
    {
      title: 'Our Story',
      content:
        "Founded by a team of experts in genetics, healthcare, and bioinformatics, Prevomics Healthscience emerged with the goal of making advanced genetic testing accessible and understandable for everyone. We believe that genetic testing should not be limited to the elite or only those facing major health issues. Instead, we envision a world where genetic insights are a routine part of healthcare — helping individuals to make proactive health decisions that improve the quality and longevity of their lives.",
    },
  ];

  const box = [
    {
      title: 'DNA Testing for Health Risks',
      desc: 'Explore your genetic makeup to uncover predispositions to diseases, genetic disorders, and more.',
      hoverColor: 'hover:bg-blue-500',
      shadowColor: 'hover:shadow-blue-600',
    },
    {
      title: 'Personalized Medicine',
      desc: 'Our pharmacogenetics services help tailor medication to your specific genetic profile, improving treatment efficacy and minimizing risks.',
      hoverColor: 'hover:bg-green-500',
      shadowColor: 'hover:shadow-green-600',
    },
    {
      title: 'Genetic Counselling',
      desc: 'Whether you’re just starting your genetic testing journey or you need support understanding your results, our certified genetic counsellors are here to help you every step of the way.',
      hoverColor: 'hover:bg-yellow-500',
      shadowColor: 'hover:shadow-yellow-600',
    },
    {
      title: 'Presymptomatic Testing',
      desc: 'Understand your risk for future genetic conditions and make proactive health decisions before problems arise.',
      hoverColor: 'hover:bg-pink-500',
      shadowColor: 'hover:shadow-pink-600',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative w-full h-screen flex items-center">
        <img
          src="./images/Dnaabt.jpg"
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="relative z-10 flex items-center bg-gradient-to-r from-black/70 to-transparent text-white pl-10 pr-6 py-20 lg:w-1/2">
          <div>
            <h1 className="text-4xl lg:text-5xl font-bold mb-6">
              {cont[0].title}
            </h1>
            <p className="text-lg lg:text-xl leading-relaxed">{cont[0].content}</p>
          </div>
        </div>
      </div>

      {cont.slice(1).map((data, index) => (
        <div key={index} className="py-12 px-6">
          <h1 className="text-2xl lg:text-center py-8">{data.title}</h1>
          <p className="text-sm lg:text-lg leading-relaxed text-gray-700">
            {data.content}
          </p>
        </div>
      ))}

      <div className="text-2xl lg:text-center py-8">
        <h2 className="mb-8">What We Do?</h2>
        <div className="grid gap-x-8 gap-y-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 px-6">
          {box.map((item, index) => (
            <div
              key={index}
              className={`p-4 bg-white rounded-md shadow-md transition-all duration-300 ${item.hoverColor}`}
            >
              <h3 className="text-lg font-medium mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div
      className="py-[120px] bg-center bg-cover bg-no-repeat"
      style={{ backgroundImage: "url('/images/main-home/why-choose-us-bg.jpg')" }}
    >
      <div className="container mx-auto">
        <div className="grid lg:grid-cols-3 gap-8 items-center">
          {/* Left Section */}
          <div className="lg:col-span-2" data-aos="fade-up-left">
            <div className="mb-8">
              <h4 className="text-xl font-semibold">Why Choose Us</h4>
              <h1 className="text-4xl font-bold">Advanced Treatments</h1>
              <h1 className="text-4xl font-bold">Compassionate Care</h1>
              <p className="pt-4 text-gray-600 w-[76%]">
                Completely e-enable covalent functionalities and market positioning
                infomediaries. Interactively initiate exceptional
              </p>
            </div>
            <div className="relative mt-10 pt-10 border-t border-gray-200">
              {/* Service Boxes */}
              <div className="grid md:grid-cols-2 gap-8">
                {[
                  {
                    icon: "choose_icon01.png",
                    title: "Industry Experience",
                    description:
                      "Completely enable covalent function and market positioning infomediarie exceptional supply",
                  },
                  {
                    icon: "choose_icon02.png",
                    title: "Medicine Expert",
                    description:
                      "Completely enable covalent function and market positioning infomediarie exceptional supply",
                  },
                  {
                    icon: "choose_icon03.png",
                    title: "Disease Analysis",
                    description:
                      "Completely enable covalent function and market positioning infomediarie exceptional supply",
                  },
                  {
                    icon: "choose_icon03.png",
                    title: "Customer Focus",
                    description:
                      "Completely enable covalent function and market positioning infomediarie exceptional supply",
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="flex gap-5 items-start hover:shadow-lg transition"
                    data-aos="flip-left"
                  >
                    <div className="w-16 h-16 rounded-full bg-blue-900 flex items-center justify-center transition">
                      {/* <img
                        src={`/assets/images/main-home/${item.icon}`}
                        alt="icon"
                        className="w-8 h-8 transition hover:invert"
                      /> */}
                    </div>
                    <div>
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">
                        {item.title}
                      </h4>
                      <p className="text-gray-600 text-sm">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div
            className="relative text-center p-10 bg-center bg-cover rounded-lg"
            style={{
              backgroundImage:
                "url('images/choose_aptmn_img.png')",
              top: "130px",
            }}
            data-aos="fade-down"
          >
           
            <div className="mt-6">
              <h2 className="text-2xl font-medium text-white leading-[34px]">
                Begin Your Journey with Prevomics
              </h2>
              <p className="text-sm text-white/60 mt-4">
                Completely enable covalent function positioning infomediarie
              </p>
            </div>
            <div className="mt-8">
              <a
                href="/"
                className="inline-block bg-blue-500 text-white py-2 px-6 rounded hover:bg-blue-600 transition"
              >
                Appointment <i className="flaticon flaticon-right-arrow"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-[#041c33] py-[90px] px-10">
      <div className="container mx-auto">
        <div className="flex flex-wrap">
          {/* Left Section */}
          <div className="w-full lg:w-1/2">
            <div className="pr-[75px]">
              <div className="space-y-8">
                <div className="relative overflow-hidden rounded-lg h-96">
                  <img src="images/case_img.png" alt="" className="w-full" />
                  

                </div>
               
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="w-full lg:w-1/2">
            <div>
              <div className="mb-10">
                <h4 className="text-secondary text-2xl">Our Values</h4>
               
              </div>

              <div className="relative pt-5">
                <ul className="space-y-8 text-white/75 text-lg">
                  <li className="flex items-center"><i className="bi bi-check-circle-fill text-secondary mr-3"></i> Integrity: We believe in providing clear, accurate, and transparent information that empowers you to make the best health decisions for you and your family.</li>
                  <li className="flex items-center"><i className="bi bi-check-circle-fill text-secondary mr-3"></i> Empathy: We understand that genetic testing can feel overwhelming. Our team is here to guide and support you through each step of your journey with compassion and clarity.</li>
                  <li className="flex items-center"><i className="bi bi-check-circle-fill text-secondary mr-3"></i> Innovation: At the heart of our mission is a commitment to staying at the forefront of genetic science, ensuring our clients benefit from the latest advancements in personalized healthcare.</li>
                </ul>
                <div className="absolute left-0 top-0 w-2/3 h-[1px] bg-white/10"></div>
              </div>

              
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>
  );
};

export default AboutPage;
